export default "__VITE_ASSET__DrKzSVeD__"